import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

// Activation toggle confirmation. Single AlertDialog parameterised by
// `pendingAction` — re-uses the same component for both directions so
// copy lives in one place.
export default function ActivationConfirmDialog({
  pendingAction, setPendingAction, toggling, customerName, onConfirm,
}) {
  return (
    <AlertDialog
      open={pendingAction !== null}
      onOpenChange={(open) => { if (!open && !toggling) setPendingAction(null); }}
    >
      <AlertDialogContent data-testid="activation-confirm-dialog">
        {pendingAction === 'deactivate' ? (
          <>
            <AlertDialogHeader>
              <AlertDialogTitle>Deactivate this customer?</AlertDialogTitle>
              <AlertDialogDescription>
                Are you sure you want to deactivate this customer? They will no longer be able to log in or make bookings.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel disabled={toggling}>Cancel</AlertDialogCancel>
              <AlertDialogAction
                onClick={onConfirm}
                disabled={toggling}
                className="bg-rose-600 hover:bg-rose-700 text-white"
                data-testid="confirm-deactivate-btn"
              >
                {toggling ? 'Working…' : 'Deactivate'}
              </AlertDialogAction>
            </AlertDialogFooter>
          </>
        ) : (
          <>
            <AlertDialogHeader>
              <AlertDialogTitle>
                Activate {customerName || 'this customer'}&apos;s account?
              </AlertDialogTitle>
              <AlertDialogDescription>
                They will regain access to log in and create bookings.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel disabled={toggling}>Cancel</AlertDialogCancel>
              <AlertDialogAction
                onClick={onConfirm}
                disabled={toggling}
                data-testid="confirm-activate-btn"
              >
                {toggling ? 'Working…' : 'Activate'}
              </AlertDialogAction>
            </AlertDialogFooter>
          </>
        )}
      </AlertDialogContent>
    </AlertDialog>
  );
}
